import { render, staticRenderFns } from "./dggx-list.vue?vue&type=template&id=3b3e4526&scoped=true&"
import script from "./dggx-list.vue?vue&type=script&lang=js&"
export * from "./dggx-list.vue?vue&type=script&lang=js&"
import style0 from "./dggx-list.vue?vue&type=style&index=0&id=3b3e4526&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b3e4526",
  null
  
)

export default component.exports